define("settings/components/meta-ad-accounts-card/group-ad-accounts-tab/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/fetch", "later/utils/to-array", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _fetch, _toArray, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/fetch",0,"later/utils/to-array",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck }}
  <section class="tAC--mmaGroupTab qa--mmaGroupTab">
    <div class="tAC--mmaGroupTab__headingRow">
      <h4 class="tAC--mmaGroupTab__heading qa--mmaGroupTab__heading">
        {{t "account.groups.group.meta_ad_accounts.heading"}}
      </h4>
      {{#if this.hasMetaAdUser}}
        <Shared::Ui::Button
          @onClick={{this.openAddModal}}
          @text={{t "account.groups.group.meta_ad_accounts.add_pill_button"}}
          @variant="primary"
          class="tAC--mmaGroupTab__addPill qa--mmaGroupTab__addPill"
        />
      {{/if}}
    </div>
  
    {{#if this.adAccounts.length}}
      <table class="tAC--mmaGroupTab__table qa--mmaGroupTab__table">
        <thead>
          <tr>
            <th class="tAC--mmaGroupTab__th tAC--mmaGroupTab__th--name">
              {{t "account.groups.group.meta_ad_accounts.columns.name"}}
            </th>
            <th class="tAC--mmaGroupTab__th tAC--mmaGroupTab__th--addedBy">
              {{t "account.groups.group.meta_ad_accounts.columns.added_by"}}
            </th>
            <th class="tAC--mmaGroupTab__th tAC--mmaGroupTab__th--actions">
              {{t "account.groups.group.meta_ad_accounts.columns.actions"}}
            </th>
          </tr>
        </thead>
        <tbody>
          {{#each this.adAccounts as |adAccount|}}
            <tr class="tAC--mmaGroupTab__tr qa--mmaGroupTab__row" data-ad-account-id={{adAccount.id}}>
              <td class="tAC--mmaGroupTab__td tAC--mmaGroupTab__td--name qa--mmaGroupTab__name">
                {{adAccount.name}}
              </td>
              <td class="tAC--mmaGroupTab__td tAC--mmaGroupTab__td--addedBy qa--mmaGroupTab__addedBy">
                {{this.addedByLabel adAccount}}
              </td>
              <td class="tAC--mmaGroupTab__td tAC--mmaGroupTab__td--actions">
                <Shared::Ui::Button
                  @isDisabled={{not (this.canRemove adAccount)}}
                  @onClick={{fn this.triggerRemove adAccount}}
                  @text={{t "account.groups.group.meta_ad_accounts.remove_button"}}
                  @variant="mute"
                  class="qa--mmaGroupTab__removeBtn"
                />
              </td>
            </tr>
          {{/each}}
        </tbody>
      </table>
    {{else}}
      <p class="tAC--mmaGroupTab__empty qa--mmaGroupTab__empty">
        {{t "account.groups.group.meta_ad_accounts.empty"}}
      </p>
    {{/if}}
  
    {{#if this.showAddModal}}
      <MetaAdAccountsCard::GroupAdAccountsTab::AddModal @group={{@group}} @onClose={{this.closeAddModal}} />
    {{/if}}
  </section>
  */
  {
    "id": "GVMG8M5e",
    "block": "[[[10,\"section\"],[14,0,\"tAC--mmaGroupTab qa--mmaGroupTab\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tAC--mmaGroupTab__headingRow\"],[12],[1,\"\\n    \"],[10,\"h4\"],[14,0,\"tAC--mmaGroupTab__heading qa--mmaGroupTab__heading\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.groups.group.meta_ad_accounts.heading\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasMetaAdUser\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"tAC--mmaGroupTab__addPill qa--mmaGroupTab__addPill\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"openAddModal\"]],[28,[37,0],[\"account.groups.group.meta_ad_accounts.add_pill_button\"],null],\"primary\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"adAccounts\",\"length\"]],[[[1,\"    \"],[10,\"table\"],[14,0,\"tAC--mmaGroupTab__table qa--mmaGroupTab__table\"],[12],[1,\"\\n      \"],[10,\"thead\"],[12],[1,\"\\n        \"],[10,\"tr\"],[12],[1,\"\\n          \"],[10,\"th\"],[14,0,\"tAC--mmaGroupTab__th tAC--mmaGroupTab__th--name\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"account.groups.group.meta_ad_accounts.columns.name\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"th\"],[14,0,\"tAC--mmaGroupTab__th tAC--mmaGroupTab__th--addedBy\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"account.groups.group.meta_ad_accounts.columns.added_by\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"th\"],[14,0,\"tAC--mmaGroupTab__th tAC--mmaGroupTab__th--actions\"],[12],[1,\"\\n            \"],[1,[28,[35,0],[\"account.groups.group.meta_ad_accounts.columns.actions\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"tbody\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"adAccounts\"]]],null]],null],null,[[[1,\"          \"],[10,\"tr\"],[14,0,\"tAC--mmaGroupTab__tr qa--mmaGroupTab__row\"],[15,\"data-ad-account-id\",[30,1,[\"id\"]]],[12],[1,\"\\n            \"],[10,\"td\"],[14,0,\"tAC--mmaGroupTab__td tAC--mmaGroupTab__td--name qa--mmaGroupTab__name\"],[12],[1,\"\\n              \"],[1,[30,1,[\"name\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"td\"],[14,0,\"tAC--mmaGroupTab__td tAC--mmaGroupTab__td--addedBy qa--mmaGroupTab__addedBy\"],[12],[1,\"\\n              \"],[1,[28,[30,0,[\"addedByLabel\"]],[[30,1]],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"td\"],[14,0,\"tAC--mmaGroupTab__td tAC--mmaGroupTab__td--actions\"],[12],[1,\"\\n              \"],[8,[39,2],[[24,0,\"qa--mmaGroupTab__removeBtn\"]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[28,[37,5],[[28,[30,0,[\"canRemove\"]],[[30,1]],null]],null],[28,[37,6],[[30,0,[\"triggerRemove\"]],[30,1]],null],[28,[37,0],[\"account.groups.group.meta_ad_accounts.remove_button\"],null],\"mute\"]],null],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,2],[14,0,\"tAC--mmaGroupTab__empty qa--mmaGroupTab__empty\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"account.groups.group.meta_ad_accounts.empty\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,0,[\"showAddModal\"]],[[[1,\"    \"],[8,[39,7],null,[[\"@group\",\"@onClose\"],[[30,2],[30,0,[\"closeAddModal\"]]]],null],[1,\"\\n\"]],[]],null],[13]],[\"adAccount\",\"@group\"],false,[\"t\",\"if\",\"shared/ui/button\",\"each\",\"-track-array\",\"not\",\"fn\",\"meta-ad-accounts-card/group-ad-accounts-tab/add-modal\"]]",
    "moduleName": "settings/components/meta-ad-accounts-card/group-ad-accounts-tab/index.hbs",
    "isStrictMode": false
  });
  let GroupAdAccountsTabComponent = _exports.default = (_class = class GroupAdAccountsTabComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "store", _descriptor4, this);
      _initializerDefineProperty(this, "showAddModal", _descriptor5, this);
      // Owning user OR account owner can remove. Account-owner check covers admins;
      // the backend enforces the same gate so this is a UI affordance, not a
      // security boundary. See MetaAdAccountPolicy#remove_from_group?.
      _defineProperty(this, "canRemove", adAccount => {
        const currentUser = this.auth.currentUserModel;
        if (!currentUser) return false;
        if (currentUser.isAccountOwner) return true;
        return adAccount.owningUser?.id === currentUser.id;
      });
      _defineProperty(this, "addedByLabel", adAccount => adAccount.owningUser?.name || adAccount.owningUser?.email || '');
      _defineProperty(this, "remove", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (adAccount) {
          const confirmed = yield this.dialogManager.confirmation(this.intl.t('account.groups.group.meta_ad_accounts.remove_confirm.title'), {
            description: this.intl.t('account.groups.group.meta_ad_accounts.remove_confirm.description', {
              name: adAccount.name,
              groupName: this.args.group.name
            }),
            confirmButton: this.intl.t('account.groups.group.meta_ad_accounts.remove_confirm.confirm_button')
          });
          if (!confirmed) return;
          yield (0, _fetch.fetch)(`/api/v2/groups/${this.args.group.id}/meta_ad_accounts/${adAccount.id}`, {
            method: 'DELETE'
          });
          // Reload the group so the embedded metaAdAccounts hasMany re-syncs after
          // the join row is destroyed. Live array — the table re-renders.
          yield this.store.findRecord('group', this.args.group.id, {
            reload: true
          });
        }
      }), {
        drop: true
      }, "remove", null));
    }
    get hasMetaAdUser() {
      return Boolean(this.auth.currentUserModel?.metaAdUser);
    }
    get adAccounts() {
      return (0, _toArray.default)(this.args.group.metaAdAccounts).filter(a => !a.disconnectedTime);
    }
    triggerRemove(adAccount) {
      void this.remove.perform(adAccount);
    }
    openAddModal() {
      this.showAddModal = true;
    }
    closeAddModal() {
      this.showAddModal = false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showAddModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "triggerRemove", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerRemove"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAddModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openAddModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeAddModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAddModal"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GroupAdAccountsTabComponent);
});